// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_5_wrapper__3hgJN"};